import React from "react";
import ComicBase from "../ComicBase";

export default function ComicKimetsu() {
  return (
    <ComicBase
      titulo="CHUN LI finds a new GYM Partner [Potions]"
      portada="https://i.ibb.co/jZb54bWy/chun-li-finds-a-new-gym-partner-1.jpg"
      
      paginas={[
        "https://fullcomics18.org/img23/chun-li-finds-a-new-gym-partner-1.jpg",
        "https://fullcomics18.org/img23/chun-li-finds-a-new-gym-partner-2.jpg",
        "https://fullcomics18.org/img23/chun-li-finds-a-new-gym-partner-3.jpg",
        "https://fullcomics18.org/img23/chun-li-finds-a-new-gym-partner-4.jpg",
        "https://fullcomics18.org/img23/chun-li-finds-a-new-gym-partner-5.jpg",
        "https://fullcomics18.org/img23/chun-li-finds-a-new-gym-partner-6.jpg",
        "https://fullcomics18.org/img23/chun-li-finds-a-new-gym-partner-7.jpg",
        "https://fullcomics18.org/img23/chun-li-finds-a-new-gym-partner-8.jpg",
        "https://fullcomics18.org/img23/chun-li-finds-a-new-gym-partner-9.jpg",
        "https://fullcomics18.org/img23/chun-li-finds-a-new-gym-partner-10.jpg",
        "https://fullcomics18.org/img23/chun-li-finds-a-new-gym-partner-11.jpg",
        "https://fullcomics18.org/img23/chun-li-finds-a-new-gym-partner-12.jpg",
        "https://fullcomics18.org/img23/chun-li-finds-a-new-gym-partner-13.jpg",
        "https://fullcomics18.org/img23/chun-li-finds-a-new-gym-partner-14.jpg",
        "https://fullcomics18.org/img23/chun-li-finds-a-new-gym-partner-15.jpg",
      ]}

      sugeridos={[
      
      ]}

      info={{
        grupo: "Video Juegos",
        tipo: "Potions",
        idioma: "Español",
        serie: "Street Fighter",
        personajes: [
          "Chun li",
        ],
        etiquetas: ["Gimnasio", "Interracial", " Inteligencia Artificial"],
        artistas: "",
      }}
    />
  );
}

export const infoManga = {
  titulo: "CHUN LI finds a new GYM Partner [Potions]",
  portada: "https://fullcomics18.org/img23/chun-li-finds-a-new-gym-partner-1.jpg",
  reverso: "https://fullcomics18.org/img23/chun-li-finds-a-new-gym-partner-2.jpg", // Primera página para el holograma trasero
        fecha:"2026-05-9", // 👈 MOVER AQUÍ

  info: {
        grupo: "Video Juegos",
        tipo: "Potions",
        idioma: "Español",
        serie: "Street Fighter",
        personajes: [
          "Chun li",
        ],
        etiquetas: ["Gimnasio", "Interracial", " Inteligencia Artificial"],
        artistas: "",
  },
};
